import { BooleanFormType } from "Store/interfaces/FormTypes";
import { UserIdentificationData } from "Store/userIdentification";
import { formBooleanToBoolean } from "Utils/formUtils";
import { isYoungUser } from "./isYoungUser";

export const usedByYoungerDriver = (
  user: UserIdentificationData | null,
  usedByYoungerDriverFieldValue: BooleanFormType | undefined,
  carOwnerAge: number | undefined,
): boolean => {
  if (isYoungUser(user, carOwnerAge)) {
    return true;
  }

  return formBooleanToBoolean(usedByYoungerDriverFieldValue);
};
